export enum PromotionTypeEnum {
  buy_x_get_x = 'buy_x_get_x',
  buy_x_get_y = 'buy_x_get_y',
  buy_x_get_ds = 'buy_x_get_ds',
  // buy_x_a_discount_price = 'buy_x_a_discount_price',
  buy_x_u_get_spp = 'buy_x_u_get_spp',
  buy_x_set_u_get_cbd = 'buy_x_set_u_get_cbd',
  buy_x_set_a_get_cbp = 'buy_x_set_a_get_cbp',
  buy_x_set_a_get_rd = 'buy_x_set_a_get_rd',
  buy_x_set_a_get_cst_by_price = 'buy_x_set_a_get_cst_by_price',
  buy_x_set_u_get_cst_by_unit = 'buy_x_set_u_get_cst_by_unit',
}